import styled from 'styled-components';

import { getLineMinHeight } from 'approot/activity-builder/theme/activity-builder-theme.utils';
import {
  richtextCommonCss,
  RichtextProps,
} from 'approot/shared/richtext/richtext.style';
import { rem } from 'approot/shared/style';
import {
  coolGrey1,
  grey1,
  grey3,
  grey6,
  grey9,
} from 'approot/shared/styles/colours.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import { fontWeightMedium } from 'approot/shared/styles/typography.style';

type TabeleCellEditViewProps = {
  $highlight?: boolean;
  $baseFontSize: number;
  $rows?: number;
  $baseLineHeight?: number;
  $isAnswer?: boolean;
};

export const TableCellEditView = styled.div.attrs<
  TabeleCellEditViewProps & RichtextProps
>({
  $isSmall: true,
})<TabeleCellEditViewProps>`
  color: ${({ $isAnswer }) => ($isAnswer ? grey6 : grey9)};
  border: 1px solid ${({ $highlight }) => ($highlight ? coolGrey1 : grey1)};
  height: 100%;
  min-height: ${({ $baseFontSize }) => rem(getLineMinHeight($baseFontSize))};
  padding: ${rem(spacing8)} ${rem(spacing16)};

  ${({ $isAnswer }) =>
    $isAnswer &&
    `
    background-color: ${grey3};
  `};

  ${richtextCommonCss}

  p {
    color: ${({ $isAnswer }) => ($isAnswer ? grey6 : grey9)};
  }

  ${props =>
    props.$highlight &&
    `
      p {
        font-weight: ${fontWeightMedium};
      }
  `}

  ${({ $baseLineHeight, $baseFontSize, $rows }) =>
    $rows &&
    $baseLineHeight &&
    `
    // the 18px is 8px top padding + 8px bottom padding + 2px borders 
    min-height: ${rem(
      $rows > 1 ? $baseLineHeight * $rows + 18 : getLineMinHeight($baseFontSize)
    )};
  `}
`;
